import React from "react";
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from "../../context/CartContext";
import './CardWidget.css';

const CardWidget = () => {
  const { cart } = useCart();
  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="cart-widget">
      <FaShoppingCart className="cart-widget-icon" />
      {totalItems > 0 && (
        <span className="cart-widget-badge">{totalItems}</span>
      )}
    </div>
  );
};

export default CardWidget;